<template>
  <b-container>
    <b-row>
      <b-col cols="12" class="mb-1" v-if="quiz.name">
        Name:
        <b>{{ quiz.name }}</b>
      </b-col>
      <b-col cols="12" class="mb-1" v-if="quiz.venue_name">
        <div>Online and offline at:</div>
        <b>{{ quiz.venue_name }}</b>
      </b-col>
      <b-col cols="12" class="mb-1" v-if="quiz.event_time > 0"
        >Date: {{ eventDate }}</b-col
      >
      <b-col cols="12" class="mb-1" v-if="quiz.rounds"
        >Rounds: {{ quiz.rounds.length }}</b-col
      >
      <b-col
        cols="12"
        class="mb-1"
        v-for="round in quiz.rounds"
        v-bind:key="round.id"
      >
        <div class="pl-3">
          <span>{{ round.name }}</span>
          <span class="pl-1">({{ scoreInfo(round) }})</span>
        </div>
      </b-col>
      <b-col cols="12" class="mb-0" v-if="quiz.link_to_website">
        <ExternalLink :link="quiz.link_to_website" />Web link set
      </b-col>
      <b-col cols="12" class="mb-1" v-if="quiz.link_to_stream">
        <ExternalLink :link="quiz.link_to_stream" />Stream link set
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ExternalLink from "@/components/ExternalLink";

export default {
  name: "NewQuizPreview",
  props: ["quiz"],
  components: { ExternalLink },
  computed: {
    eventDate() {
      return this.$moment(this.quiz.event_time).format("YYYY-MM-DD HH:MM");
    }
  },
  methods: {
    scoreInfo(round) {
      var info = round.score_max;
      if (round.allow_half_points) {
        info += ", ½";
      }
      return info;
    }
  }
};
</script>
